import { useEffect, useState } from "react";
import apiClient from "@/lib/api";
import { FileText, Calendar, MessageSquare, Newspaper, Mail, Sparkles, Gift, Handshake, Scale, GraduationCap, Route, Users } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    apiClient.get("/admin/stats").then((r) => setStats(r.data));
  }, []);

  const cards = stats
    ? [
        { icon: FileText, label: "PR Assessments", value: stats.pr_assessments },
        { icon: FileText, label: "Student PR Assessments", value: stats.student_pr_assessments || 0 },
        { icon: Calendar, label: "Consultations", value: stats.consultations },
        { icon: MessageSquare, label: "Contact Messages", value: stats.contact_messages },
        { icon: Newspaper, label: "Blog Posts", value: stats.blog_posts },
        { icon: Mail, label: "Newsletter Subscribers", value: stats.newsletter },
      ]
    : [];

  const toolCards = stats
    ? [
        { icon: Route, label: "Smart Pathway Assessments", value: stats.pathway_assessments || 0 },
        { icon: GraduationCap, label: "485 Pathway Planner", value: stats.g485_planner || 0 },
        { icon: Gift, label: "Referrals", value: stats.referrals || 0 },
        { icon: Handshake, label: "Education Agent Partners", value: stats.agent_partnerships || 0 },
        { icon: Scale, label: "RMA Network Applications", value: stats.rma_applications || 0 },
        { icon: Sparkles, label: "Skilled Migration Assessments", value: stats.skilled_migration || 0 },
        { icon: Users, label: "Parent Visa Assessments", value: stats.parent_visa || 0 },
        { icon: GraduationCap, label: "485 Visa Assessments", value: stats.graduate_485 || 0 },
      ]
    : [];

  return (
    <div data-testid="admin-dashboard" className="p-8">
      <h1 className="font-display text-3xl text-[#29324A]">Dashboard</h1>
      <p className="text-sm text-slate-500 mt-1">Overview of submissions and content.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mt-8">
        {cards.map((c, i) => (
          <div key={i} data-testid={`stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`} className="bg-white border border-slate-200 p-6">
            <c.icon className="h-5 w-5 text-[#C43A89] mb-3" />
            <div className="text-xs font-semibold tracking-wider uppercase text-slate-500">{c.label}</div>
            <div className="font-display text-4xl text-[#29324A] mt-1 tabular-nums">{c.value}</div>
          </div>
        ))}
      </div>

      <div className="mt-10">
        <h2 className="font-display text-xl text-[#29324A]">Assessment Tools &amp; Smart Pathways</h2>
        <p className="text-xs text-slate-500 mt-0.5">Leads from the interactive tools — full details in <strong>All Leads &amp; Inbox</strong>.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
          {toolCards.map((c, i) => (
            <div key={i} data-testid={`stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`} className="bg-gradient-to-br from-[#29324A] to-[#5A3A8B] text-white p-6">
              <c.icon className="h-5 w-5 text-[#C43A89] mb-3" />
              <div className="text-xs font-semibold tracking-wider uppercase text-slate-300">{c.label}</div>
              <div className="font-display text-4xl mt-1 tabular-nums">{c.value}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-12 bg-white border border-slate-200 p-6">
        <h2 className="font-display text-xl text-[#29324A] mb-2">Quick start</h2>
        <ul className="text-sm text-slate-600 space-y-1.5 list-disc pl-5">
          <li>Every form and assessment tool feeds into <strong>All Leads &amp; Inbox</strong> — open any lead there for the full submission.</li>
          <li>Use the sidebar to review PR Assessments, Consultations and Messages.</li>
          <li>Edit 485 planner fees, English scores and review dates in <strong>485 Assessment Rules</strong>.</li>
          <li>Go to the <strong>Blog Manager</strong> to publish new articles.</li>
          <li>Form submissions are also emailed to yasmin@studynet.com.au (when Resend is configured).</li>
        </ul>
      </div>
    </div>
  );
}
